import { Action } from 'redux';
import { IAPICompanyFullInfo, IAPIGameItem } from '../../../model/api-modules';

export enum ReduxStudioActionType {
  STUDIO_LIST = 'STUDIO_LIST',
  SELECT_STUDIO = 'SELECT_STUDIO',
  SET_CERT = 'SET_CERT',
}

export interface IStudioListStudioAction extends Action {
  type: ReduxStudioActionType.STUDIO_LIST;
  result: IAPIGameItem[];
}

export interface ISelectStudioAction extends Action {
  type: ReduxStudioActionType.SELECT_STUDIO;
  result: IAPIGameItem | null;
}

export interface ISetStudioCert extends Action {
  type: ReduxStudioActionType.SET_CERT;
  result: Record<string, IAPICompanyFullInfo | null | undefined>;
}

export type StudioAction =
  | ISelectStudioAction
  | IStudioListStudioAction
  | ISetStudioCert;

export interface IStudioState {
  readonly selectStudio: IAPIGameItem | null;
  readonly studioList: IAPIGameItem[];
  readonly studioCert: Record<string, IAPICompanyFullInfo | null | undefined>;
}
